var _g, _g2;
var _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
var SvgAuthorization = function SvgAuthorization(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 350 350",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    fill: "none",
    id: "canvas_background",
    height: 352,
    width: 352,
    y: -1,
    x: -1
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    stroke: "null",
    id: "svg_1",
    fill: "#f5f5f5",
    r: 169,
    cy: 175,
    cx: 175
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_2",
    fill: "none",
    d: "m57.37,309.29l0,-0.52l-0.35,0.32l0.35,0.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_3",
    fill: "#f5f5f5",
    d: "m411.83,217.79a5.28,5.28 0 0 1 0.38,-0.75a5.28,5.28 0 0 0 -0.38,0.75z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_5",
    fill: "#f5f5f5",
    d: "m413,217a8.14,8.14 0 0 1 0.84,-1.6l0,0a8.14,8.14 0 0 0 -0.84,1.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_6",
    fill: "#f5f5f5",
    d: "m411.3,221a7.36,7.36 0 0 1 0.53,-3.18a7.36,7.36 0 0 0 -0.53,3.18z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_7",
    fill: "#f5f5f5",
    d: "m413,217a6.74,6.74 0 0 0 -0.42,1.66a6.74,6.74 0 0 1 0.42,-1.66z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "svg_11"
  }, /*#__PURE__*/React.createElement("path", {
    id: "svg_8",
    fill: "#cecece",
    d: "m261.75222,131.71382c-0.65,0.33 -1.33,0.05 -2,0.05q-80.16,0 -160.3,-0.05c-6.65,0 -11,5.34 -11.59,11c-0.49,4.78 -1,9.56 -1.68,14.32c-0.52,3.61 -0.82,7.24 -1.26,10.86c-0.54,4.53 -1.15,9.05 -1.71,13.58c-0.52,4.29 -1,8.59 -1.52,12.88s-1.15,8.37 -1.69,12.56c-0.45,3.57 -0.81,7.14 -1.24,10.71s-1,7.32 -1.39,11c-0.36,3 -0.64,6.09 -1,9.14c0,0.42 0.11,0.89 -0.32,1.22l0,-11.77c0.47,-0.44 0.28,-1 0.28,-1.52c0,-38.62 0.19,-116.95 -0.28,-117.38c0,-5.15 4.71,-10 10,-10.29l72.91,0c1.32,0 6.52,-0.49 10.28,1.73c1.4,0.83 6.86,8.48 8.54,10.88a2.6,2.6 0 0 0 2.41,1.23q35.06,-0.06 70.13,0a10.82,10.82 0 0 1 10.2,6.18a10.08,10.08 0 0 1 1.13,4.81q0.08,4.4 0.1,8.86z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_9",
    fill: "#dcdcdc",
    d: "m104.09222,131.92382l158.53,0l0.13,-0.16c5.6,0.22 9.9,3.46 11,8.23a9.68,9.68 0 0 1 0.11,3.22c-0.92,8.64 -1.87,17.29 -2.79,25.93s-1.82,17.3 -2.74,26c-0.94,8.89 -1.91,17.78 -2.86,26.67c-0.71,6.6 -1.33,13.22 -2.12,19.82a11.43,11.43 0 0 1 -8.94,10.2a12.89,12.89 0 0 1 -2.48,0.18l-162.17,0a13,13 0 0 1 -11.88,-6.77c-1.13,-1.94 -0.78,-4.07 -0.73,-6.16c0.43,-0.33 0.27,-0.8 0.32,-1.22c0.31,-3.05 0.59,-6.1 0.95,-9.14c0.43,-3.66 0.94,-7.32 1.39,-11s0.79,-7.14 1.24,-10.71c0.54,-4.19 1.16,-8.37 1.69,-12.56s1,-8.58 1.52,-12.88c0.56,-4.53 1.17,-9 1.71,-13.58c0.44,-3.62 0.75,-7.25 1.26,-10.86c0.68,-4.76 1.19,-9.54 1.68,-14.32c0.57,-5.67 4.94,-11 11.59,-11"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_10",
    fill: "#98a8b7",
    d: "m85.77222,169.52382c0.34,-4 0.73,-7.95 1.12,-11.92s0.77,-8 1.19,-11.92l0,0.09a15.93,15.93 0 0 1 1.11,-5.83a12.13,12.13 0 0 1 3.53,-4.84a9,9 0 0 1 1.24,-0.89l0.63,-0.41l0.69,-0.32c0.47,-0.19 0.92,-0.45 1.4,-0.59l1.44,-0.41a9.06,9.06 0 0 1 1.47,-0.27l1.48,-0.19l2.92,0l24.67,-0.14c8.23,0 16.45,0 24.68,0.07s16.45,0.14 24.67,0.28q6.16,0.09 12.34,0.25c4.11,0.1 8.22,0.18 12.33,0.33c-4.11,0.16 -8.22,0.25 -12.33,0.36s-8.22,0.21 -12.33,0.27q-12.33,0.22 -24.66,0.32c-8.22,0.09 -16.44,0.09 -24.66,0.12l-24.67,-0.09l-2.81,0l-1.35,0.15a8.58,8.58 0 0 0 -1.33,0.22l-1.3,0.33a11.08,11.08 0 0 0 -1.24,0.5l-0.62,0.25l-0.56,0.35a8.14,8.14 0 0 0 -1.1,0.74a10.45,10.45 0 0 0 -3.21,4.2a14.26,14.26 0 0 0 -1.2,5.26l0,0.13l0,0q-0.83,5.93 -1.71,11.85c-0.63,3.86 -1.2,7.81 -1.83,11.75z"
  })))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAuthorization, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/authorization.b0f88ce5.svg";
export { ForwardRef as ReactComponent };